'use client';
import { useTranslations } from 'next-intl';
import style from './variants.module.scss';
import ProductDto from '@/projectRoot/api-client/interfaces/models/products/Product.dto';
import Close from '../../svg/Close';
import { orderedSizes } from '@/projectRoot/src/utils/constants/orderSizes';
import StockVariant from '@/projectRoot/api-client/interfaces/models/products/product-entities/StockVariant.dto';
import { useCart } from '@/projectRoot/src/contexts/CartContext';

interface Props {
    product: ProductDto;
    closeWindow?: () => void;
    classes?: string[];
}

const Variants = ({product, closeWindow, classes = []}: Props) => {
    const t = useTranslations();
    const {cartDispatchAction, showCartShortcut} = useCart();
    const onAddToCart = (variant: StockVariant) => {
        if(variant.stock_count < 1) return;
        cartDispatchAction({type: 'addProduct', payload: {
            product_id: product.id,
            quantity: 1,
            stock_variant: variant.stock_variant
        }});
        showCartShortcut(true);
    }

  return (
    <>
        <div className={`${style.variantsWindow} ${classes.join(' ')}`} onClick={(e) => e.stopPropagation()}>
            <p className={style.title}>
                {product.title}
            </p>
            <span className={style.closeBtn} onClick={closeWindow}>
                <Close width={8} height={8} />
            </span>
            <p>
                {t('selected_color')}
                <span>
                    {product.color.title}
                </span>
            </p>
            <p>{t('selected_size')}</p>
            <div className={style.variants}>
                {
                    product.stock_variants.map(
                        (vr) => { return { ...vr, order: orderedSizes.indexOf(vr.stock_variant) != -1 ? orderedSizes.indexOf(vr.stock_variant) : 1000 } }
                    ).sort((a, b) => a.order - b.order).map((variant, index) => 
                        <span 
                            key={variant.stock_variant + index}
                            className={`${style.variant} ${variant.stock_count == 0 ? style.disabled : ''}`}
                            onClick={() => onAddToCart(variant)}
                        >
                            {variant.stock_variant}
                        </span>
                    )
                }
            </div>
        </div>
    </>
  )
};

export default Variants;
